"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _Collapse = _interopRequireDefault(require("./Collapse"));

exports["default"] = _Collapse["default"];